// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"src_sync_recursive_":"7c5dd280","node_modules_dompurify_dist_purify_js":"d074f811","node_modules_canvg_lib_index_es_js":"959d30ca"}[chunkId] + ".js";
};